/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Remind_Sms_TextInputs */

const en_portal_remind_sms_text = /** @type {(inputs: Portal_Remind_Sms_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tomorrow at 18:00, a 1:1 session with Kasia Nowak. See you there!`)
};

const pl_portal_remind_sms_text = /** @type {(inputs: Portal_Remind_Sms_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jutro o 18:00 trening 1:1 z Kasią Nowak. Do zobaczenia!`)
};

/**
* | output |
* | --- |
* | "Tomorrow at 18:00, a 1:1 session with Kasia Nowak. See you there!" |
*
* @param {Portal_Remind_Sms_TextInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_remind_sms_text = /** @type {((inputs?: Portal_Remind_Sms_TextInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Remind_Sms_TextInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_remind_sms_text(inputs)
	return en_portal_remind_sms_text(inputs)
});